import { useNavigate, useSearchParams } from 'react-router-dom';
import { MultiStepAuth } from '@/components/auth/MultiStepAuth';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const Auth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const redirectTo = searchParams.get('redirect');

  // Redirect authenticated users
  useEffect(() => {
    const mode = searchParams.get('mode');
    const prefillEmail = searchParams.get('email');
    
    if (user) {
      if (redirectTo) {
        navigate(decodeURIComponent(redirectTo));
      } else {
        navigate('/');
      }
    }
  }, [user, navigate, redirectTo, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-hero flex flex-col">
      <Header />
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <img 
              src="/lovable-uploads/b27056c0-a4ae-4dfc-97cd-db68e05f48cd.png" 
              alt="GreatJobs.lk" 
              className="h-10 w-auto"
            />
          </div>
          <p className="text-white/80">Join Sri Lanka's premier AI-powered job platform</p>
        </div>

        <MultiStepAuth />

        <div className="text-center mt-6">
          <Button variant="ghost" className="text-white/80 hover:text-white" onClick={() => navigate('/')}>
            ← Back to Home
          </Button>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Auth;